import mwrHttp from '@/utils/activityHttp'
import store from '@/store'
import ActAccountApi from '@/config/actAccountApi'
import { trackLogin, PAGE_SOURCE_IN, markPageSourceFromQuery } from './utils/track'

const isDev = process.env.VUE_APP_ENV === 'dev'
let accountBasePath = isDev
  ? '/minifire_account_server_os/api/v1'
  : 'https://wapi.miniworldplus.com:1443/minifire_account_server_os/api/v1'

if (process.env.VUE_APP_ENV === 'prod') {
  accountBasePath = 'https://wapi.miniworldgame.com/minifire_account_server_os/api/v1'
}

let basePath = isDev
  ? '/minifire-monopoly/api/v1/mp'
  : 'https://wapi.miniworldplus.com:1443/minifire-monopoly/api/v1/mp'

if (process.env.VUE_APP_ENV === 'prod') {
  basePath = 'https://wapi.miniworldgame.com/minifire-monopoly/api/v1/mp'
}

const commitActUser = (res) => {
  store.commit('SET_ACT_USER_INFO', {
    token: res.authorization,
    expireAt: res.expireAt,
    ...res.roleInfo,
  })
}

export default {
  ...ActAccountApi,

  // 覆盖：端内静默登录成功后上报再跳转（reload 前同步 track）
  gameTokenLogin: async (params) => {
    markPageSourceFromQuery({ tokenHash: params?.tokenHash })
    try {
      const res = await mwrHttp.post(`${accountBasePath}/game/gameTokenLogin`, params)
      commitActUser(res)
      trackLogin(PAGE_SOURCE_IN)
    } catch (error) {
      console.error(error)
    }
    location.href = location.origin + location.pathname
  },

  getActivityInfo: (params = {}) => {
    return mwrHttp.post(`${basePath}/activity-info`, params)
  },
  getCommonConfig: (params = {}) => {
    return mwrHttp.post(`${basePath.replace(/\/mp$/, '')}/get-common-config`, params)
  },
  getRankList: (params = {}) => {
    return mwrHttp.post(`${basePath}/rank-list`, params)
  },
  getRewardRecord: (params = {}) => {
    return mwrHttp.post(`${basePath}/reward-record`, params)
  },
  roll: (params = {}) => {
    return mwrHttp.post(`${basePath}/roll`, params)
  },
  claimDailyDice: (params = {}) => {
    return mwrHttp.post(`${basePath}/claim-daily-dice`, params)
  },
  extractRewards: (params = {}) => {
    return mwrHttp.post(`${basePath}/extract-rewards`, params)
  },
  getLapRewardList: (params = {}) => {
    return mwrHttp.post(`${basePath}/lap-reward-list`, params)
  },
  receiveLapReward: (params = {}) => {
    return mwrHttp.post(`${basePath}/receive-lap-reward`, params)
  },
}
